import http from '@utils/http.js'

export const notifications = () => {
    const actionFeedContainer = document.getElementById('user-notifications')

    if (!actionFeedContainer) {
        return
    }

    const actionFeed = actionFeedContainer.querySelector('.user-notifications')
    const actionForm = actionFeedContainer.querySelector('form')

    if (!actionForm) {
        return
    }

    function submit(page, append) {
        const pager = actionForm.querySelector('.pager')
        pager.classList.add('loading')
        const skeleton = document.createElement('div')
        skeleton.className = 'user-action-wrapper skeleton'
        skeleton.innerHTML =
            '<div class="user-action-artwork"><i class="icon--user-action"></i></div>'
        actionFeed.appendChild(skeleton)

        const params = {
            append,
            page,
        }

        http.get(actionForm.getAttribute('action'), { params })
            .then(function (response) {
                pager.classList.remove('loading')
                skeleton.remove()
                actionFeed.insertAdjacentHTML('beforeend', response.data)
                const end = actionFeed.querySelector('.end')
                if (end) {
                    end.remove()
                    actionForm.style.display = 'none'
                    actionFeed.classList.add('at-end')
                }
            })
            .catch(function (error) {
                console.error('Error:', error)
            })
    }

    actionForm.querySelector('.pager').addEventListener('click', function (e) {
        if (this.classList.contains('loading')) {
            e.preventDefault()
            return
        }

        const page = this.previousElementSibling
        const event = new Event('submit')

        page.value = parseInt(page.value) + 1
        actionForm.dispatchEvent(event)

        submit(page.value, true)
    })
}
